import TableWrapper from './table-wrapper'
export default TableWrapper
